var AnalyticServiceVendor;
(function (AnalyticServiceVendor) {
    AnalyticServiceVendor["GoogleTagManager"] = "gtm";
})(AnalyticServiceVendor || (AnalyticServiceVendor = {}));
export default AnalyticServiceVendor;
//# sourceMappingURL=analytics-service-vendor-type.js.map